const organizations = {
    title: 'Organizzazioni',
    description: 'Crea e gestisci le organizzazioni di cui fai parte.',
    create: 'Crea organizzazione',
    create_title: 'Crea una nuova organizzazione',
    name: 'Nome dell’organizzazione',
    avatar: 'Avatar dell’organizzazione',
    avatar_removed: 'Avatar dell’organizzazione rimosso.',
    description_label: 'Descrizione',
    empty: 'Non appartieni ancora a un’organizzazione.',
    pending_invitations: 'Inviti in attesa',
    accept: 'Accetta',
    decline: 'Rifiuta',
    owner: 'Proprietario',
    tabs: {
        overview: 'Panoramica',
        members: 'Membri',
        invitations: 'Inviti',
        roles: 'Ruoli di gestione',
        branding: 'Identità visiva',
        security: 'Sicurezza',
        jit: 'Provisioning JIT',
        applications: 'Risorse condivise',
        activity: 'Attività',
        deletion: 'Elimina',
    },
    members: {
        title: 'Membri',
        empty: 'Nessun membro trovato.',
        remove: 'Rimuovi',
        removed: 'Membro rimosso.',
        business_roles: 'Ruoli aziendali',
        no_business_roles: 'Nessun ruolo aziendale disponibile. Chiedi all’amministratore del tenant di condividere i ruoli con questa organizzazione.',
    },
    invitations: {
        title: 'Inviti',
        invite: 'Invita membro',
        email: 'Indirizzo e-mail',
        empty: 'Nessun invito trovato.',
        resend: 'Invia di nuovo',
        resent: 'Invito inviato di nuovo.',
        revoke: 'Revoca',
        revoked: 'Invito revocato.',
        status: {
            Pending: 'In attesa',
            Accepted: 'Accettato',
            Expired: 'Scaduto',
            Revoked: 'Revocato',
            Declined: 'Rifiutato',
        },
    },
    roles: {
        title: 'Ruoli di gestione',
        create: 'Crea ruolo',
        permissions: 'Permessi',
        empty: 'Nessun ruolo di gestione trovato.',
        select_member: 'Seleziona membro',
        select_role: 'Seleziona ruolo',
        assign: 'Assegna ruolo',
        assigned: 'Ruolo assegnato.',
        unassign: 'Rimuovi ruolo',
        unassigned: 'Ruolo rimosso.',
        permission_count: 'Permessi: {{count}}',
        built_in: {
            owner: 'Proprietario',
            owner_description: 'I proprietari hanno il controllo esclusivo sulla proprietà e sull’eliminazione dell’organizzazione.',
            administrator: 'Amministratore',
            administrator_description: 'Gestisce l’organizzazione tranne le azioni riservate ai proprietari.',
        },
        permission_labels: {
            update_profile: 'Aggiorna profilo',
            manage_branding: 'Gestisci identità visiva',
            view_members: 'Visualizza membri',
            manage_members: 'Gestisci membri',
            manage_invitations: 'Gestisci inviti',
            assign_business_roles: 'Assegna ruoli aziendali',
            manage_management_roles: 'Gestisci ruoli di gestione',
            assign_management_roles: 'Assegna ruoli di gestione',
            manage_security: 'Gestisci sicurezza',
            manage_jit: 'Gestisci provisioning JIT',
            manage_applications: 'Gestisci applicazioni',
            view_activity: 'Visualizza attività',
        },
    },
    branding: {
        title: 'Identità visiva dell’organizzazione',
        primary_color: 'Colore principale',
        custom_css: 'CSS personalizzato',
        preview: 'Anteprima',
        light: 'Chiaro',
        dark: 'Scuro',
    },
    security: {
        title: 'Sicurezza dell’organizzazione',
        require_mfa: 'Richiedi l’autenticazione a più fattori ai membri',
    },
    jit: {
        title: 'Domini e-mail JIT',
        domain: 'Dominio e-mail',
        add: 'Aggiungi dominio',
        verify: 'Verifica DNS',
        dns_instruction: 'Crea il record TXT {{record}} con il valore {{value}}.',
        verified: 'Verificato',
    },
    applications: {
        title: 'Risorse condivise',
        empty: 'Nessuna risorsa disponibile per questa organizzazione.',
        sso: 'Connessioni SSO aziendali',
        m2m: 'Applicazioni machine-to-machine',
    },
    activity: {
        title: 'Attività dell’organizzazione',
        empty: 'Nessuna attività.',
        events: {
            create: 'Organizzazione creata',
            delete: 'Organizzazione eliminata',
            profile: 'Profilo dell’organizzazione aggiornato',
            branding: 'Identità visiva aggiornata',
            security: 'Sicurezza dell’organizzazione aggiornata',
            member_add: 'Membro aggiunto',
            member_remove: 'Membro rimosso',
            owner: 'Proprietà dell’organizzazione aggiornata',
            role_create: 'Ruolo di gestione creato',
            role_update: 'Ruolo di gestione aggiornato',
            role_delete: 'Ruolo di gestione eliminato',
            role_assign: 'Ruolo di gestione assegnato',
            role_unassign: 'Ruolo di gestione rimosso dal membro',
            business_role: 'Ruoli aziendali aggiornati',
            invitation_create: 'Invito inviato',
            invitation_accept: 'Invito accettato',
            invitation_decline: 'Invito rifiutato',
            invitation_revoke: 'Invito revocato',
            jit: 'Provisioning JIT aggiornato',
            domain: 'Verifica del dominio e-mail',
            application: 'Connessioni delle applicazioni aggiornate',
            unknown: 'Attività dell’organizzazione',
        },
    },
    save: 'Salva modifiche',
    cancel: 'Annulla',
    delete: 'Elimina organizzazione',
    delete_confirmation: 'L’organizzazione e le sue appartenenze verranno eliminate definitivamente. Inserisci “{{name}}” per confermare.',
    deleted: 'Organizzazione eliminata.',
    load_failed: 'Impossibile caricare i dati dell’organizzazione. Riprova.',
    permission_denied: 'Non hai il permesso di visualizzare questa sezione.',
};
export default organizations;
